<template>
  <img class="marker" width="25" height="44" src="https://api.longdo.com/map/images/pin.png" />
</template>

<script>
export default {
  name: 'MapMarker'
};
</script>

<style lang="scss" scoped>
.marker {
  position: absolute;
  text-align: left;
  z-index: 10;
  top: calc(50% - 22px);
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
